import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    chats: [],
};

export const meetingChatSlice = createSlice({
    name: 'meetingChat',
    initialState,
    reducers: {
        setMeetingChats: (state, action) => {
            state.chats = action.payload;
        },
        chatMessageReceived: (state, action) => {
            const { groupId, message } = action.payload;
            const chat = state.chats.find(c => c.id === groupId);
            if (!chat) return;

            
            if (chat.messages.some(m => m.id === message.id)) return;

            chat.messages.push(message);
            chat.updatedAt = message.createdAt;

            
            state.chats.sort((a, b) => {
                const aTime = a.messages?.length > 0 
                    ? new Date(a.messages[a.messages.length - 1].createdAt).getTime() 
                    : new Date(a.updatedAt || 0).getTime();
                const bTime = b.messages?.length > 0 
                    ? new Date(b.messages[b.messages.length - 1].createdAt).getTime() 
                    : new Date(b.updatedAt || 0).getTime();
                return bTime - aTime;
            });
        },
        chatMessageDeleted: (state, action) => {
            const { messageId, groupId } = action.payload;
            const chat = state.chats.find(c => c.id === groupId);
            if (!chat) return;

            const deletedMessage = chat.messages.find(m => m.id === messageId);
            const wasLastMessage = chat.messages.length > 0 && 
                chat.messages[chat.messages.length - 1]?.id === messageId;

            chat.messages = chat.messages.filter(m => m.id !== messageId);
            
            if (wasLastMessage && chat.messages.length > 0) {
                chat.updatedAt = chat.messages[chat.messages.length - 1].createdAt;
            } else if (wasLastMessage && chat.messages.length === 0) {
                chat.updatedAt = deletedMessage?.createdAt || chat.updatedAt;
            }

            state.chats.sort((a, b) => {
                const aTime = a.messages?.length > 0 
                    ? new Date(a.messages[a.messages.length - 1].createdAt).getTime() 
                    : new Date(a.updatedAt || 0).getTime();
                const bTime = b.messages?.length > 0 
                    ? new Date(b.messages[b.messages.length - 1].createdAt).getTime() 
                    : new Date(b.updatedAt || 0).getTime();
                return bTime - aTime;
            });
        },        
        chatListUpdate: (state, action) => {
            const { groupId, lastMessage, updatedAt, userDetailsId, selectedChatId, isDeleteUpdate, deletedMessageId } = action.payload;            
            const chat = state.chats.find(c => c.id === groupId);
            if (!chat) return;
            
            
            if (isDeleteUpdate && deletedMessageId) {
                
                const deletedMessage = chat.messages.find(m => m.id == deletedMessageId);
                
                
                const wasUnreadByCurrentUser = deletedMessage && 
                    deletedMessage.unreadBy && 
                    Array.isArray(deletedMessage.unreadBy) && 
                    deletedMessage.unreadBy.some(unread => unread.id == userDetailsId);
                
                
                chat.messages = chat.messages.filter(m => m.id != deletedMessageId);
                
                
                if (lastMessage) {
                    const lastMessageIndex = chat.messages.findIndex(m => m.id == lastMessage.id);
                    if (lastMessageIndex !== -1) {
                        chat.messages[lastMessageIndex] = lastMessage;
                    } else {
                        chat.messages.push(lastMessage);
                    }
                }
                
                
                if (userDetailsId && wasUnreadByCurrentUser && chat.unreadCount > 0) {
                    chat.unreadCount = chat.unreadCount - 1;
                }
                
                chat.updatedAt = updatedAt;
            } else {
                
                const isFromCurrentUser = lastMessage.sender?.id === parseInt(userDetailsId);
                const isCurrentlyViewing = selectedChatId === groupId;

                const lastMessageIndex = chat.messages.findIndex(m => m.id === lastMessage.id);
                if (lastMessageIndex !== -1) {
                    chat.messages[lastMessageIndex] = lastMessage;
                } else {                
                    chat.messages.push(lastMessage);
                                    
                    if (!isFromCurrentUser && !isCurrentlyViewing && userDetailsId) {
                        chat.unreadCount = (chat.unreadCount || 0) + 1;
                    }
                }
                
                chat.updatedAt = updatedAt;
            }

            

            state.chats.sort((a, b) => {
                const aTime = a.messages?.length > 0 
                    ? new Date(a.messages[a.messages.length - 1].createdAt).getTime() 
                    : new Date(a.updatedAt || 0).getTime();
                const bTime = b.messages?.length > 0 
                    ? new Date(b.messages[b.messages.length - 1].createdAt).getTime() 
                    : new Date(b.updatedAt || 0).getTime();
                return bTime - aTime;
            });
        },
        markMessagesAsRead: (state, action) => {
            const { groupId, userDetailsId } = action.payload;
            const chat = state.chats.find(c => c.id === groupId);
            if (!chat) return;

            
            chat.messages.forEach(message => {
                if (message.unreadBy && Array.isArray(message.unreadBy)) {
                    message.unreadBy = message.unreadBy.filter(
                        unread => unread.id !== parseInt(userDetailsId)
                    );
                }
            });

            
            chat.unreadCount = 0;
        },
        clearChatMessages: (state, action) => {
            const { groupId } = action.payload;
            const chat = state.chats.find(c => c.id === groupId);
            if (!chat) return;


            chat.messages = [];
            chat.unreadCount = 0;
        },
    }
});

export const { 
    setMeetingChats, 
    chatMessageReceived, 
    chatMessageDeleted,     
    chatListUpdate,
    markMessagesAsRead,
    clearChatMessages
} = meetingChatSlice.actions;

export default meetingChatSlice.reducer;

